import { Icon, Icons, Intent, List, ListItem, Size } from "construct-ui";
import Sortable from 'sortablejs';

let uniqueInstance = 1;

/**
 * Sortable List Component
 * 
 * @author CV Leong
 */
export default function SortableListComponent() {

  const COMPONENT_DEFAULT_ID = `sortable-list-${uniqueInstance++}`;

  let sortable;
  let updatedItems;

  let _onChange = (itemList, itemKeyOrder) => { };

  const _onOrderChange = (e) => {
    _onChange(updatedItems, sortable.toArray());
  };

  const initSortableById = (id) => {
    var dList = document.getElementById(id);
    sortable = new Sortable(dList, {
      animation: 150,
      ghostClass: 'sortable-ghost',
      dragClass: 'sortable-drag',
      handle: '.drag-grip',
      onUpdate: _onOrderChange,
    });
  }

  const removeListItem = (itemKey, itemList, itemKeyAttr) => {
    itemList = itemList.filter(i => i[itemKeyAttr] !== itemKey);
    let itemKeyOrder = sortable.toArray().filter(key => key !== itemKey);
    _onChange(itemList, itemKeyOrder);
  }

  return {
    oninit: ({ attrs: { onChange = _onChange } }) => {
      _onChange = onChange;
    },
    oncreate: ({ attrs: { id = COMPONENT_DEFAULT_ID, items } }) => {
      updatedItems = items;
      initSortableById(id);
      _onChange(updatedItems, sortable.toArray());
    },
    view: ({ attrs: {
      itemKey = 'code',
      itemValue = 'name',
      id = COMPONENT_DEFAULT_ID,
      isItemRemovable = true,
      items,
      listItemAttrs,
      ...listAttrs
    } }) => {
      updatedItems = items;
      return [
        m(List, { id, ...listAttrs },
          items?.map(item => [
            m(ListItem, {
              ...listItemAttrs,
              class: `drag-grip ${listItemAttrs?.['class'] || ''}`,
              contentLeft: listItemAttrs?.contentLeft || m('i.bi.bi-grip-vertical.me-3'),
              contentRight: listItemAttrs?.contentRight || isItemRemovable && m(Icon, {
                intent: Intent.NEGATIVE,
                name: Icons.MINUS_CIRCLE,
                size: Size.XS,
                onclick: () => {
                  removeListItem(item[itemKey], items, itemKey);
                }
              }),
              key: item[itemKey],
              label: `${item[itemValue]}`,
              'data-id': item[itemKey],
              title: listItemAttrs?.title || (listItemAttrs?.showKeyInTitle === true ? item[itemKey] : listItemAttrs?.showValueInTitle ? item[itemValue] : undefined),
            })
          ])
        )
      ]
    }
  }
}
